const animation = {
    v: "5.9.0",
    fr: 60,
    ip: 0,
    op: 90,
    w: 400,
    h: 400,
    nm: "spinnerColor",
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Square",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [100, 100, 0], ix: 2, l: 2 },
                a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                s: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.523, 0.523, 0.667], y: [1, 1, 1] },
                            o: { x: [0.154, 0.154, 0.333], y: [0, 0, 0] },
                            t: 0,
                            s: [100, 100, 100],
                        },
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                            t: 24,
                            s: [60, 60, 100],
                        },
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                            t: 47,
                            s: [60, 60, 100],
                        },
                        { t: 69, s: [100, 100, 100] },
                    ],
                    ix: 6,
                    l: 2,
                },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ty: "rc",
                            d: 1,
                            s: { a: 0, k: [180, 180], ix: 2 },
                            p: { a: 0, k: [0, 0], ix: 3 },
                            r: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.382], y: [1] },
                                        o: { x: [0.119], y: [0] },
                                        t: 0,
                                        s: [2],
                                    },
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.333], y: [0] },
                                        t: 24,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.333], y: [0] },
                                        t: 47,
                                        s: [100],
                                    },
                                    { t: 69, s: [2] },
                                ],
                                ix: 4,
                            },
                            nm: "Rectangle Path 1",
                            mn: "ADBE Vector Shape - Rect",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.333], y: [0] },
                                        t: 0,
                                        s: [1, 0.886274509804, 0.38431372549, 1],
                                    },
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.333], y: [0] },
                                        t: 24,
                                        s: [1, 0.666666666667, 0.050980392157, 1],
                                    },
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.334], y: [0] },
                                        t: 37,
                                        s: [1, 0.666666666667, 0.050980392157, 1],
                                    },
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.01], y: [0.004] },
                                        t: 47,
                                        s: [1, 0.666666666667, 0.050980392157, 1],
                                    },
                                    {
                                        i: { x: [0.667], y: [1] },
                                        o: { x: [0.167], y: [0.044] },
                                        t: 69,
                                        s: [1, 0.886274509804, 0.38431372549, 1],
                                    },
                                    { t: 85, s: [1, 0.886274509804, 0.38431372549, 1] },
                                ],
                                ix: 4,
                            },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [0, 0], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transformer ",
                        },
                    ],
                    nm: "Rectangle 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 90,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Polygon",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.769], y: [0] },
                            t: 0,
                            s: [0],
                        },
                        { t: 65, s: [240] },
                    ],
                    ix: 10,
                },
                p: { a: 0, k: [80, 300, 0], ix: 2, l: 2 },
                a: { a: 0, k: [-129, 100, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ty: "sr",
                            sy: 2,
                            d: 1,
                            pt: { a: 0, k: 3, ix: 3 },
                            p: { a: 0, k: [0, 0], ix: 4 },
                            r: { a: 0, k: 90, ix: 5 },
                            or: { a: 0, k: 100, ix: 7 },
                            os: { a: 0, k: 0, ix: 9 },
                            ix: 1,
                            nm: "Polystar Path 1",
                            mn: "ADBE Vector Shape - Star",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: { a: 0, k: [0.109803921569, 0.56862745098, 1, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [-129, 100], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transformer ",
                        },
                    ],
                    nm: "Polystar 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 90,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Circle",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: {
                    a: 1,
                    k: [
                        {
                            i: { x: 0.833, y: 0.833 },
                            o: { x: 0.333, y: 0 },
                            t: 20,
                            s: [300, 220, 0],
                            to: [0.333, -20, 0],
                            ti: [0, 3.515, 0],
                        },
                        {
                            i: { x: 0.833, y: 0.833 },
                            o: { x: 0.167, y: 0.167 },
                            t: 29,
                            s: [300, 100, 0],
                            to: [0, -2.998, 0],
                            ti: [0, -24.529, 0],
                        },
                        {
                            i: { x: 0.833, y: 0.833 },
                            o: { x: 0.167, y: 0.167 },
                            t: 35,
                            s: [300, 159.995, 0],
                            to: [0, 16.378, 0],
                            ti: [0, -10.001, 0],
                        },
                        { t: 78, s: [300, 220, 0] },
                    ],
                    ix: 2,
                    l: 2,
                },
                a: { a: 0, k: [73.582, -126.582, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            d: 1,
                            ty: "el",
                            s: { a: 0, k: [200, 200], ix: 2 },
                            p: { a: 0, k: [0, 0], ix: 3 },
                            nm: "Ellipse Path 1",
                            mn: "ADBE Vector Shape - Ellipse",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [0.254901960784, 0.545098039216, 0.360784313725, 1],
                                ix: 4,
                            },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [73.582, -126.582], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transformer ",
                        },
                    ],
                    nm: "Ellipse 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 90,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: "Square 2",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [300, 390, 0], ix: 2, l: 2 },
                a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                s: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.833, 0.88, 0.833], y: [1, 0.691, 1] },
                            o: { x: [0.167, 0.338, 0.167], y: [0, 0, 0] },
                            t: 20,
                            s: [100, 33, 100],
                        },
                        {
                            i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
                            o: { x: [0.194, 0.016, 0.194], y: [0, 0, 0] },
                            t: 25,
                            s: [100, 66, 100],
                        },
                        {
                            i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                            o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                            t: 35,
                            s: [100, 66, 100],
                        },
                        { t: 78, s: [100, 33, 100] },
                    ],
                    ix: 6,
                    l: 2,
                },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ty: "rc",
                            d: 1,
                            s: { a: 0, k: [180, 180], ix: 2 },
                            p: { a: 0, k: [0, 0], ix: 3 },
                            r: { a: 0, k: 2, ix: 4 },
                            nm: "Rectangle Path 1",
                            mn: "ADBE Vector Shape - Rect",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.633], y: [-14.18] },
                                        o: { x: [0.288], y: [0] },
                                        t: 0,
                                        s: [0.882352941176, 0.262745098039, 0.133333333333, 1],
                                    },
                                    {
                                        i: { x: [0.663], y: [0.864] },
                                        o: { x: [0.329], y: [0.113] },
                                        t: 20,
                                        s: [0.882352941176, 0.262745098039, 0.133333333333, 1],
                                    },
                                    {
                                        i: { x: [0.403], y: [1] },
                                        o: { x: [0], y: [0] },
                                        t: 25,
                                        s: [1, 0.764705882353, 0.874509803922, 1],
                                    },
                                    {
                                        i: { x: [1], y: [1] },
                                        o: { x: [0.341], y: [0] },
                                        t: 35,
                                        s: [1, 0.764705882353, 0.874509803922, 1],
                                    },
                                    {
                                        t: 85,
                                        s: [0.882352941176, 0.262745098039, 0.133333333333, 1],
                                    },
                                ],
                                ix: 4,
                            },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [0, 0], ix: 2 },
                            a: { a: 0, k: [0, 90], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transformer ",
                        },
                    ],
                    nm: "Rectangle 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 90,
            st: 0,
            bm: 0,
        },
    ],
    markers: [],
};
export default animation;
//# sourceMappingURL=spinnerColor.js.map